<header>
  <div class="container-fluid">
    <nav class="navbar">
      <div class="logo">
        <img src="KabbodleLogo.png" class="logoimg" alt="Kaboodle Logo" />
      </div>
      <button class="mobile-menu-btn" aria-label="Toggle menu" (click)="toggleSidebar()">
        <span></span>
        <span></span>
        <span></span>
      </button>
      <aside class="custom-sidebar" [class.open]="isSidebarOpen">
        <div class="auth-buttons authbut" *ngIf="!isLoggedIn">
          <a class="btn btn-secondary btnsec" (click)="openEnquiryModal()">Enquire Now</a>
          <a class="btn btn-primary btnsec" (click)="openLoginModal()">Login</a>
          <!-- <a  class="btn btn-primary btnsec" (click)="openSignupModal()">Sign Up</a> -->
        </div>
        <div *ngIf="isLoggedIn" class="user-actions">
          <img [src]="profilePhoto || '/nophoto.jpg'" referrerpolicy="no-referrer" alt="Profile"
            class="profile-img" />
          <span class="left10">Welcome, <span class="user-name">{{ fullname }}</span></span>
        </div>
        <!-- <div class="dropdown-divider"></div> -->
        <!-- <button class="dropdown-item" (click)="toggleDropdownsubaside($event)">
                  My Learning ▶
        </button> -->
        <div class="border-bot"><a *ngIf="isLoggedIn" class="btn btn-secondarymylerningside"
            (click)="toggleDropdownsubaside($event)">My Learning</a></div>
        <div class="border-bot" [routerLink]="['/home']"> <a class="btn-secondarymylerningside">Home</a></div>
        <div class="border-bot" [routerLink]="['/']"> <a class="btn-secondarymylerningside">Courses</a></div>
        <div class="border-bot"> <a class="btn-secondarymylerningside"
            href="https://www.kaboodleinnovations.com/privacy-policy">Privacy Policy</a></div>
        <div class="profile-dropdownsub course-dropdown" *ngIf="isDropdownOpenSubmenuAside">

          <div class="course-card" (click)="toggleDropdownsubUp($event);navgate(traininCourses.trainingCourseName)">

            <div class="course-icon" *ngIf="user?.data?.userType !== 'USER'">
              <i><img src="Training-Main-page-image.png" class="mycourseImagemobile" /></i>
            </div>

            <div class="course-details" *ngIf="user?.data?.userType !== 'USER'">
              <div class="course-name">
                {{traininCourses.trainingCourseName}}
              </div>

              <div class="course-action"
                (click)="toggleDropdownsubUp($event);navgate(traininCourses.trainingCourseName)">
                View Course →
              </div>
            </div>
            <div class="session-container" *ngIf="user?.data?.userType === 'USER'">
              <app-nodata-found></app-nodata-found>
            </div>

          </div>

        </div>
        <!-- <div class="profile-dropdownsub" *ngIf="isDropdownOpenSubmenuAside">
                    <button class="dropdown-item1" (click)="toggleDropdownsubUp($event);navgate(traininCourses.trainingCourseName)">
                      {{traininCourses.trainingCourseName}}
                    </button>
                  <div class="dropdown-divider"></div>

        </div> -->
        <button *ngIf="isLoggedIn" class="btn btn-primaryforLogout logoutbtn" (click)="logout()">
          Logout <i class="bi bi-box-arrow-right"></i>
        </button>

      </aside>
      <div class="nav-container">
        <div class="nav-links">

        </div>
        <div class="auth-buttons" *ngIf="!isLoggedIn">
          <a class="btn btn-secondary" (click)="openEnquiryModal()">Enquire Now</a>
          <a class="btn btn-primary" (click)="openLoginModal()">Login</a>
          <!-- <a  class="btn btn-primary" (click)="openSignupModal()">Sign Up</a> -->
        </div>
        <div *ngIf="isLoggedIn" class="user-actions">
          <a class="btn btn-secondarymylerning" (click)="toggleLearningSidebar()">
            My Learning
          </a>
          <div class="profile-container" (click)="toggleDropdown()" tabindex="0">

            <!-- Profile Image -->
            <img [src]="profilePhoto || '/nophoto.jpg'" alt="Profile" class="profile-img" />

            <!-- Dropdown -->
            <div class="profile-dropdown" *ngIf="isDropdownOpen">

              <!-- User Info -->
              <div class="profile-header">
                <img [src]="profilePhoto || '/nophoto.jpg'" class="dropdown-img" />

                <div class="user-info">
                  <div class="user-name">
                    <span style="color:#1e1d1d;">Welcome,</span>
                    {{ fullname }}
                  </div>
                </div>
              </div>

              <!-- <div class="dropdown-divider"></div> -->

              <!-- Wrap button + submenu -->

              <!-- <div class="submenu-wrapper"> -->

              <!-- <button class="dropdown-item" (click)="toggleDropdownsub($event)">
                  My Learning ▶
                </button> -->

              <!-- NOW INSIDE -->
              <!-- <div class="profile-dropdownsub" *ngIf="isDropdownOpenSubmenu">
                  <button class="dropdown-item1"
                    (click)="toggleDropdownsubUp($event);navgate(traininCourses.trainingCourseName)">
                    {{traininCourses.trainingCourseName}}
                  </button>
                  <div class="dropdown-divider"></div>

                </div>

              </div> -->

              <div class="dropdown-divider"></div>

              <button *ngIf="isLoggedIn" class="btn btn-primaryforLogout" (click)="logout()">
                Logout <i class="bi bi-box-arrow-right"></i>
              </button>

            </div>
            <!-- Desktop Sidebar -->
            <div class="learning-sidebar" [class.open]="isLearningSidebarOpen">

              <div class="sidebar-header" *ngIf="isLoggedIn">
                <h4>My Courses</h4>
                <button class="close-btn" (click)="toggleLearningSidebar()">×</button>
              </div>

              <div class="course-list" *ngIf="user?.data?.userType !== 'USER'">

                <div class="course-card" (click)="navgate(traininCourses.trainingCourseName)">

                  <i><img src="Training-Main-page-image.png"/></i>

                  <div class="course-info">
                    <div class="course-name">
                      {{ traininCourses.trainingCourseName }}
                    </div>

                    <div class="course-action">
                      View Course →
                    </div>
                  </div>

                </div>

              </div>
              <div class="session-container" *ngIf="user?.data?.userType === 'USER'">
                <app-nodata-found></app-nodata-found>
              </div>

            </div>
          </div>
          <!-- <span class="wel">Welcome, <span class="user-name">{{ fullname }}</span></span>
        <button class="btn btn-primary" (click)="logout()" style="margin-left: 10px;">Logout</button> -->
        </div>
      </div>
    </nav>
  </div>
</header>
<app-login #authModal (modalClosed)="onModalClosed()">
</app-login>